import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessTypeAppResource from "./BusinessTypeAppResource";

export const HOMEOWNERS_INSURANCE_AGENT = 'homeowners-insurance-agents';
export const REAL_ESTATE_AGENT = 'real-estate-agent';
export const HOME_INSPECTOR = 'home-inspector';
export const CREDIT_COUNSELOR = 'credit-counselor';
export const LOAN_OFFICER = 'loan-officer';
export const HOME_INSURANCE = 'homeowners-insurance';
export const REAL_ESTATE_ATTORNEY = 'real-estate-attorney';
export const HOME_WARRANTY = 'home-warranty';
export const MOVER = 'mover';
export const PHOTOGRAPHER = 'photographer';
export const HOME_STAGER = 'home-stager';
export const TITLE_ESCROW_SERVICES = 'title-escrow-services';

class ReferralPartnerTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'referral-partner-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'referrals/partners/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'namePlural',
            'slug',
            'businessTypeUuid',
            'businessType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            businessType: BusinessTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            businessType: 'business_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            namePlural: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            businessTypeUuid: {
                type: 'string',
                presence: true,
            }
        };
    }

}

export default ReferralPartnerTypeAppResource;
